/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as EmployeeRouteImport } from './routes/employee'
import { Route as PlatformRouteImport } from './routes/_platform'
import { Route as DmRouteImport } from './routes/_dm'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EmployeeIndexRouteImport } from './routes/employee/index'
import { Route as SBranchIdRouteImport } from './routes/s.$branchId'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth/verify-email'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthResendVerificationRouteImport } from './routes/_auth/resend-verification'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as EmployeeProfileIndexRouteImport } from './routes/employee/profile/index'
import { Route as EmployeePayslipsIndexRouteImport } from './routes/employee/payslips/index'
import { Route as EmployeeLoansIndexRouteImport } from './routes/employee/loans/index'
import { Route as EmployeeLeaveIndexRouteImport } from './routes/employee/leave/index'
import { Route as EmployeeAppraisalsIndexRouteImport } from './routes/employee/appraisals/index'
import { Route as PlatformPlatformIndexRouteImport } from './routes/_platform/platform/index'
import { Route as DmDistrimarketIndexRouteImport } from './routes/_dm/distrimarket/index'
import { Route as AppWebhooksIndexRouteImport } from './routes/_app/webhooks/index'
import { Route as AppStaffIndexRouteImport } from './routes/_app/staff/index'
import { Route as AppSmartspaceIndexRouteImport } from './routes/_app/smartspace/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSalesIndexRouteImport } from './routes/_app/sales/index'
import { Route as AppReportingIndexRouteImport } from './routes/_app/reporting/index'
import { Route as AppPromotionsIndexRouteImport } from './routes/_app/promotions/index'
import { Route as AppProfileIndexRouteImport } from './routes/_app/profile/index'
import { Route as AppProductsIndexRouteImport } from './routes/_app/products/index'
import { Route as AppProcurementIndexRouteImport } from './routes/_app/procurement/index'
import { Route as AppPosIndexRouteImport } from './routes/_app/pos/index'
import { Route as AppPettyCashIndexRouteImport } from './routes/_app/petty-cash/index'
import { Route as AppPayrollIndexRouteImport } from './routes/_app/payroll/index'
import { Route as AppPaymentsIndexRouteImport } from './routes/_app/payments/index'
import { Route as AppPartnerIndexRouteImport } from './routes/_app/partner/index'
import { Route as AppInventoryIndexRouteImport } from './routes/_app/inventory/index'
import { Route as AppHospitalityIndexRouteImport } from './routes/_app/hospitality/index'
import { Route as AppFieldSalesIndexRouteImport } from './routes/_app/field-sales/index'
import { Route as AppExpensesIndexRouteImport } from './routes/_app/expenses/index'
import { Route as AppEmptiesIndexRouteImport } from './routes/_app/empties/index'
import { Route as AppDocumentsIndexRouteImport } from './routes/_app/documents/index'
import { Route as AppDashboardIndexRouteImport } from './routes/_app/dashboard/index'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers/index'
import { Route as AppBomIndexRouteImport } from './routes/_app/bom/index'
import { Route as AppBillingIndexRouteImport } from './routes/_app/billing/index'
import { Route as AppAuditIndexRouteImport } from './routes/_app/audit/index'
import { Route as AppAiIndexRouteImport } from './routes/_app/ai/index'
import { Route as AppAccountingIndexRouteImport } from './routes/_app/accounting/index'
import { Route as AppHospitalityResourcesRouteImport } from './routes/_app/hospitality/resources'
import { Route as AppHospitalityReservationsRouteImport } from './routes/_app/hospitality/reservations'
import { Route as AppHospitalityKitchenRouteImport } from './routes/_app/hospitality/kitchen'
import { Route as AppHospitalityHousekeepingRouteImport } from './routes/_app/hospitality/housekeeping'
import { Route as AppHospitalityGroupBookingsRouteImport } from './routes/_app/hospitality/group-bookings'
import { Route as AppHospitalityFoliosRouteImport } from './routes/_app/hospitality/folios'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeeRoute = EmployeeRouteImport.update({
  id: '/employee',
  path: '/employee',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformRoute = PlatformRouteImport.update({
  id: '/_platform',
  getParentRoute: () => rootRouteImport,
} as any)
const DmRoute = DmRouteImport.update({
  id: '/_dm',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeeIndexRoute = EmployeeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EmployeeRoute,
} as any)
const SBranchIdRoute = SBranchIdRouteImport.update({
  id: '/s/$branchId',
  path: '/s/$branchId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResendVerificationRoute = AuthResendVerificationRouteImport.update({
  id: '/resend-verification',
  path: '/resend-verification',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const EmployeeProfileIndexRoute = EmployeeProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => EmployeeRoute,
} as any)
const EmployeePayslipsIndexRoute = EmployeePayslipsIndexRouteImport.update({
  id: '/payslips/',
  path: '/payslips/',
  getParentRoute: () => EmployeeRoute,
} as any)
const EmployeeLoansIndexRoute = EmployeeLoansIndexRouteImport.update({
  id: '/loans/',
  path: '/loans/',
  getParentRoute: () => EmployeeRoute,
} as any)
const EmployeeLeaveIndexRoute = EmployeeLeaveIndexRouteImport.update({
  id: '/leave/',
  path: '/leave/',
  getParentRoute: () => EmployeeRoute,
} as any)
const EmployeeAppraisalsIndexRoute = EmployeeAppraisalsIndexRouteImport.update({
  id: '/appraisals/',
  path: '/appraisals/',
  getParentRoute: () => EmployeeRoute,
} as any)
const PlatformPlatformIndexRoute = PlatformPlatformIndexRouteImport.update({
  id: '/platform/',
  path: '/platform/',
  getParentRoute: () => PlatformRoute,
} as any)
const DmDistrimarketIndexRoute = DmDistrimarketIndexRouteImport.update({
  id: '/distrimarket/',
  path: '/distrimarket/',
  getParentRoute: () => DmRoute,
} as any)
const AppWebhooksIndexRoute = AppWebhooksIndexRouteImport.update({
  id: '/webhooks/',
  path: '/webhooks/',
  getParentRoute: () => AppRoute,
} as any)
const AppStaffIndexRoute = AppStaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => AppRoute,
} as any)
const AppSmartspaceIndexRoute = AppSmartspaceIndexRouteImport.update({
  id: '/smartspace/',
  path: '/smartspace/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesIndexRoute = AppSalesIndexRouteImport.update({
  id: '/sales/',
  path: '/sales/',
  getParentRoute: () => AppRoute,
} as any)
const AppReportingIndexRoute = AppReportingIndexRouteImport.update({
  id: '/reporting/',
  path: '/reporting/',
  getParentRoute: () => AppRoute,
} as any)
const AppPromotionsIndexRoute = AppPromotionsIndexRouteImport.update({
  id: '/promotions/',
  path: '/promotions/',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileIndexRoute = AppProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AppRoute,
} as any)
const AppProductsIndexRoute = AppProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => AppRoute,
} as any)
const AppProcurementIndexRoute = AppProcurementIndexRouteImport.update({
  id: '/procurement/',
  path: '/procurement/',
  getParentRoute: () => AppRoute,
} as any)
const AppPosIndexRoute = AppPosIndexRouteImport.update({
  id: '/pos/',
  path: '/pos/',
  getParentRoute: () => AppRoute,
} as any)
const AppPettyCashIndexRoute = AppPettyCashIndexRouteImport.update({
  id: '/petty-cash/',
  path: '/petty-cash/',
  getParentRoute: () => AppRoute,
} as any)
const AppPayrollIndexRoute = AppPayrollIndexRouteImport.update({
  id: '/payroll/',
  path: '/payroll/',
  getParentRoute: () => AppRoute,
} as any)
const AppPaymentsIndexRoute = AppPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => AppRoute,
} as any)
const AppPartnerIndexRoute = AppPartnerIndexRouteImport.update({
  id: '/partner/',
  path: '/partner/',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryIndexRoute = AppInventoryIndexRouteImport.update({
  id: '/inventory/',
  path: '/inventory/',
  getParentRoute: () => AppRoute,
} as any)
const AppHospitalityIndexRoute = AppHospitalityIndexRouteImport.update({
  id: '/hospitality/',
  path: '/hospitality/',
  getParentRoute: () => AppRoute,
} as any)
const AppFieldSalesIndexRoute = AppFieldSalesIndexRouteImport.update({
  id: '/field-sales/',
  path: '/field-sales/',
  getParentRoute: () => AppRoute,
} as any)
const AppExpensesIndexRoute = AppExpensesIndexRouteImport.update({
  id: '/expenses/',
  path: '/expenses/',
  getParentRoute: () => AppRoute,
} as any)
const AppEmptiesIndexRoute = AppEmptiesIndexRouteImport.update({
  id: '/empties/',
  path: '/empties/',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsIndexRoute = AppDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardIndexRoute = AppDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)
const AppBomIndexRoute = AppBomIndexRouteImport.update({
  id: '/bom/',
  path: '/bom/',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingIndexRoute = AppBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditIndexRoute = AppAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => AppRoute,
} as any)
const AppAiIndexRoute = AppAiIndexRouteImport.update({
  id: '/ai/',
  path: '/ai/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountingIndexRoute = AppAccountingIndexRouteImport.update({
  id: '/accounting/',
  path: '/accounting/',
  getParentRoute: () => AppRoute,
} as any)
const AppHospitalityResourcesRoute = AppHospitalityResourcesRouteImport.update({
  id: '/hospitality/resources',
  path: '/hospitality/resources',
  getParentRoute: () => AppRoute,
} as any)
const AppHospitalityReservationsRoute =
  AppHospitalityReservationsRouteImport.update({
    id: '/hospitality/reservations',
    path: '/hospitality/reservations',
    getParentRoute: () => AppRoute,
  } as any)
const AppHospitalityKitchenRoute = AppHospitalityKitchenRouteImport.update({
  id: '/hospitality/kitchen',
  path: '/hospitality/kitchen',
  getParentRoute: () => AppRoute,
} as any)
const AppHospitalityHousekeepingRoute =
  AppHospitalityHousekeepingRouteImport.update({
    id: '/hospitality/housekeeping',
    path: '/hospitality/housekeeping',
    getParentRoute: () => AppRoute,
  } as any)
const AppHospitalityGroupBookingsRoute =
  AppHospitalityGroupBookingsRouteImport.update({
    id: '/hospitality/group-bookings',
    path: '/hospitality/group-bookings',
    getParentRoute: () => AppRoute,
  } as any)
const AppHospitalityFoliosRoute = AppHospitalityFoliosRouteImport.update({
  id: '/hospitality/folios',
  path: '/hospitality/folios',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/employee': typeof EmployeeRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/resend-verification': typeof AuthResendVerificationRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/s/$branchId': typeof SBranchIdRoute
  '/employee/': typeof EmployeeIndexRoute
  '/hospitality/folios': typeof AppHospitalityFoliosRoute
  '/hospitality/group-bookings': typeof AppHospitalityGroupBookingsRoute
  '/hospitality/housekeeping': typeof AppHospitalityHousekeepingRoute
  '/hospitality/kitchen': typeof AppHospitalityKitchenRoute
  '/hospitality/reservations': typeof AppHospitalityReservationsRoute
  '/hospitality/resources': typeof AppHospitalityResourcesRoute
  '/accounting/': typeof AppAccountingIndexRoute
  '/ai/': typeof AppAiIndexRoute
  '/audit/': typeof AppAuditIndexRoute
  '/billing/': typeof AppBillingIndexRoute
  '/bom/': typeof AppBomIndexRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/dashboard/': typeof AppDashboardIndexRoute
  '/documents/': typeof AppDocumentsIndexRoute
  '/empties/': typeof AppEmptiesIndexRoute
  '/expenses/': typeof AppExpensesIndexRoute
  '/field-sales/': typeof AppFieldSalesIndexRoute
  '/hospitality/': typeof AppHospitalityIndexRoute
  '/inventory/': typeof AppInventoryIndexRoute
  '/partner/': typeof AppPartnerIndexRoute
  '/payments/': typeof AppPaymentsIndexRoute
  '/payroll/': typeof AppPayrollIndexRoute
  '/petty-cash/': typeof AppPettyCashIndexRoute
  '/pos/': typeof AppPosIndexRoute
  '/procurement/': typeof AppProcurementIndexRoute
  '/products/': typeof AppProductsIndexRoute
  '/profile/': typeof AppProfileIndexRoute
  '/promotions/': typeof AppPromotionsIndexRoute
  '/reporting/': typeof AppReportingIndexRoute
  '/sales/': typeof AppSalesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/smartspace/': typeof AppSmartspaceIndexRoute
  '/staff/': typeof AppStaffIndexRoute
  '/webhooks/': typeof AppWebhooksIndexRoute
  '/distrimarket/': typeof DmDistrimarketIndexRoute
  '/platform/': typeof PlatformPlatformIndexRoute
  '/employee/appraisals/': typeof EmployeeAppraisalsIndexRoute
  '/employee/leave/': typeof EmployeeLeaveIndexRoute
  '/employee/loans/': typeof EmployeeLoansIndexRoute
  '/employee/payslips/': typeof EmployeePayslipsIndexRoute
  '/employee/profile/': typeof EmployeeProfileIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/resend-verification': typeof AuthResendVerificationRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/s/$branchId': typeof SBranchIdRoute
  '/employee': typeof EmployeeIndexRoute
  '/hospitality/folios': typeof AppHospitalityFoliosRoute
  '/hospitality/group-bookings': typeof AppHospitalityGroupBookingsRoute
  '/hospitality/housekeeping': typeof AppHospitalityHousekeepingRoute
  '/hospitality/kitchen': typeof AppHospitalityKitchenRoute
  '/hospitality/reservations': typeof AppHospitalityReservationsRoute
  '/hospitality/resources': typeof AppHospitalityResourcesRoute
  '/accounting': typeof AppAccountingIndexRoute
  '/ai': typeof AppAiIndexRoute
  '/audit': typeof AppAuditIndexRoute
  '/billing': typeof AppBillingIndexRoute
  '/bom': typeof AppBomIndexRoute
  '/customers': typeof AppCustomersIndexRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/documents': typeof AppDocumentsIndexRoute
  '/empties': typeof AppEmptiesIndexRoute
  '/expenses': typeof AppExpensesIndexRoute
  '/field-sales': typeof AppFieldSalesIndexRoute
  '/hospitality': typeof AppHospitalityIndexRoute
  '/inventory': typeof AppInventoryIndexRoute
  '/partner': typeof AppPartnerIndexRoute
  '/payments': typeof AppPaymentsIndexRoute
  '/payroll': typeof AppPayrollIndexRoute
  '/petty-cash': typeof AppPettyCashIndexRoute
  '/pos': typeof AppPosIndexRoute
  '/procurement': typeof AppProcurementIndexRoute
  '/products': typeof AppProductsIndexRoute
  '/profile': typeof AppProfileIndexRoute
  '/promotions': typeof AppPromotionsIndexRoute
  '/reporting': typeof AppReportingIndexRoute
  '/sales': typeof AppSalesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/smartspace': typeof AppSmartspaceIndexRoute
  '/staff': typeof AppStaffIndexRoute
  '/webhooks': typeof AppWebhooksIndexRoute
  '/distrimarket': typeof DmDistrimarketIndexRoute
  '/platform': typeof PlatformPlatformIndexRoute
  '/employee/appraisals': typeof EmployeeAppraisalsIndexRoute
  '/employee/leave': typeof EmployeeLeaveIndexRoute
  '/employee/loans': typeof EmployeeLoansIndexRoute
  '/employee/payslips': typeof EmployeePayslipsIndexRoute
  '/employee/profile': typeof EmployeeProfileIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_dm': typeof DmRouteWithChildren
  '/_platform': typeof PlatformRouteWithChildren
  '/employee': typeof EmployeeRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/resend-verification': typeof AuthResendVerificationRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/s/$branchId': typeof SBranchIdRoute
  '/employee/': typeof EmployeeIndexRoute
  '/_app/hospitality/folios': typeof AppHospitalityFoliosRoute
  '/_app/hospitality/group-bookings': typeof AppHospitalityGroupBookingsRoute
  '/_app/hospitality/housekeeping': typeof AppHospitalityHousekeepingRoute
  '/_app/hospitality/kitchen': typeof AppHospitalityKitchenRoute
  '/_app/hospitality/reservations': typeof AppHospitalityReservationsRoute
  '/_app/hospitality/resources': typeof AppHospitalityResourcesRoute
  '/_app/accounting/': typeof AppAccountingIndexRoute
  '/_app/ai/': typeof AppAiIndexRoute
  '/_app/audit/': typeof AppAuditIndexRoute
  '/_app/billing/': typeof AppBillingIndexRoute
  '/_app/bom/': typeof AppBomIndexRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/dashboard/': typeof AppDashboardIndexRoute
  '/_app/documents/': typeof AppDocumentsIndexRoute
  '/_app/empties/': typeof AppEmptiesIndexRoute
  '/_app/expenses/': typeof AppExpensesIndexRoute
  '/_app/field-sales/': typeof AppFieldSalesIndexRoute
  '/_app/hospitality/': typeof AppHospitalityIndexRoute
  '/_app/inventory/': typeof AppInventoryIndexRoute
  '/_app/partner/': typeof AppPartnerIndexRoute
  '/_app/payments/': typeof AppPaymentsIndexRoute
  '/_app/payroll/': typeof AppPayrollIndexRoute
  '/_app/petty-cash/': typeof AppPettyCashIndexRoute
  '/_app/pos/': typeof AppPosIndexRoute
  '/_app/procurement/': typeof AppProcurementIndexRoute
  '/_app/products/': typeof AppProductsIndexRoute
  '/_app/profile/': typeof AppProfileIndexRoute
  '/_app/promotions/': typeof AppPromotionsIndexRoute
  '/_app/reporting/': typeof AppReportingIndexRoute
  '/_app/sales/': typeof AppSalesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/smartspace/': typeof AppSmartspaceIndexRoute
  '/_app/staff/': typeof AppStaffIndexRoute
  '/_app/webhooks/': typeof AppWebhooksIndexRoute
  '/_dm/distrimarket/': typeof DmDistrimarketIndexRoute
  '/_platform/platform/': typeof PlatformPlatformIndexRoute
  '/employee/appraisals/': typeof EmployeeAppraisalsIndexRoute
  '/employee/leave/': typeof EmployeeLeaveIndexRoute
  '/employee/loans/': typeof EmployeeLoansIndexRoute
  '/employee/payslips/': typeof EmployeePayslipsIndexRoute
  '/employee/profile/': typeof EmployeeProfileIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/employee'
    | '/privacy'
    | '/terms'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/resend-verification'
    | '/reset-password'
    | '/verify-email'
    | '/s/$branchId'
    | '/employee/'
    | '/hospitality/folios'
    | '/hospitality/group-bookings'
    | '/hospitality/housekeeping'
    | '/hospitality/kitchen'
    | '/hospitality/reservations'
    | '/hospitality/resources'
    | '/accounting/'
    | '/ai/'
    | '/audit/'
    | '/billing/'
    | '/bom/'
    | '/customers/'
    | '/dashboard/'
    | '/documents/'
    | '/empties/'
    | '/expenses/'
    | '/field-sales/'
    | '/hospitality/'
    | '/inventory/'
    | '/partner/'
    | '/payments/'
    | '/payroll/'
    | '/petty-cash/'
    | '/pos/'
    | '/procurement/'
    | '/products/'
    | '/profile/'
    | '/promotions/'
    | '/reporting/'
    | '/sales/'
    | '/settings/'
    | '/smartspace/'
    | '/staff/'
    | '/webhooks/'
    | '/distrimarket/'
    | '/platform/'
    | '/employee/appraisals/'
    | '/employee/leave/'
    | '/employee/loans/'
    | '/employee/payslips/'
    | '/employee/profile/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/privacy'
    | '/terms'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/resend-verification'
    | '/reset-password'
    | '/verify-email'
    | '/s/$branchId'
    | '/employee'
    | '/hospitality/folios'
    | '/hospitality/group-bookings'
    | '/hospitality/housekeeping'
    | '/hospitality/kitchen'
    | '/hospitality/reservations'
    | '/hospitality/resources'
    | '/accounting'
    | '/ai'
    | '/audit'
    | '/billing'
    | '/bom'
    | '/customers'
    | '/dashboard'
    | '/documents'
    | '/empties'
    | '/expenses'
    | '/field-sales'
    | '/hospitality'
    | '/inventory'
    | '/partner'
    | '/payments'
    | '/payroll'
    | '/petty-cash'
    | '/pos'
    | '/procurement'
    | '/products'
    | '/profile'
    | '/promotions'
    | '/reporting'
    | '/sales'
    | '/settings'
    | '/smartspace'
    | '/staff'
    | '/webhooks'
    | '/distrimarket'
    | '/platform'
    | '/employee/appraisals'
    | '/employee/leave'
    | '/employee/loans'
    | '/employee/payslips'
    | '/employee/profile'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/_dm'
    | '/_platform'
    | '/employee'
    | '/privacy'
    | '/terms'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/register'
    | '/_auth/resend-verification'
    | '/_auth/reset-password'
    | '/_auth/verify-email'
    | '/s/$branchId'
    | '/employee/'
    | '/_app/hospitality/folios'
    | '/_app/hospitality/group-bookings'
    | '/_app/hospitality/housekeeping'
    | '/_app/hospitality/kitchen'
    | '/_app/hospitality/reservations'
    | '/_app/hospitality/resources'
    | '/_app/accounting/'
    | '/_app/ai/'
    | '/_app/audit/'
    | '/_app/billing/'
    | '/_app/bom/'
    | '/_app/customers/'
    | '/_app/dashboard/'
    | '/_app/documents/'
    | '/_app/empties/'
    | '/_app/expenses/'
    | '/_app/field-sales/'
    | '/_app/hospitality/'
    | '/_app/inventory/'
    | '/_app/partner/'
    | '/_app/payments/'
    | '/_app/payroll/'
    | '/_app/petty-cash/'
    | '/_app/pos/'
    | '/_app/procurement/'
    | '/_app/products/'
    | '/_app/profile/'
    | '/_app/promotions/'
    | '/_app/reporting/'
    | '/_app/sales/'
    | '/_app/settings/'
    | '/_app/smartspace/'
    | '/_app/staff/'
    | '/_app/webhooks/'
    | '/_dm/distrimarket/'
    | '/_platform/platform/'
    | '/employee/appraisals/'
    | '/employee/leave/'
    | '/employee/loans/'
    | '/employee/payslips/'
    | '/employee/profile/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  DmRoute: typeof DmRouteWithChildren
  PlatformRoute: typeof PlatformRouteWithChildren
  EmployeeRoute: typeof EmployeeRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
  SBranchIdRoute: typeof SBranchIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employee': {
      id: '/employee'
      path: '/employee'
      fullPath: '/employee'
      preLoaderRoute: typeof EmployeeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_platform': {
      id: '/_platform'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PlatformRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dm': {
      id: '/_dm'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employee/': {
      id: '/employee/'
      path: '/'
      fullPath: '/employee/'
      preLoaderRoute: typeof EmployeeIndexRouteImport
      parentRoute: typeof EmployeeRoute
    }
    '/s/$branchId': {
      id: '/s/$branchId'
      path: '/s/$branchId'
      fullPath: '/s/$branchId'
      preLoaderRoute: typeof SBranchIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/resend-verification': {
      id: '/_auth/resend-verification'
      path: '/resend-verification'
      fullPath: '/resend-verification'
      preLoaderRoute: typeof AuthResendVerificationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/employee/profile/': {
      id: '/employee/profile/'
      path: '/profile'
      fullPath: '/employee/profile/'
      preLoaderRoute: typeof EmployeeProfileIndexRouteImport
      parentRoute: typeof EmployeeRoute
    }
    '/employee/payslips/': {
      id: '/employee/payslips/'
      path: '/payslips'
      fullPath: '/employee/payslips/'
      preLoaderRoute: typeof EmployeePayslipsIndexRouteImport
      parentRoute: typeof EmployeeRoute
    }
    '/employee/loans/': {
      id: '/employee/loans/'
      path: '/loans'
      fullPath: '/employee/loans/'
      preLoaderRoute: typeof EmployeeLoansIndexRouteImport
      parentRoute: typeof EmployeeRoute
    }
    '/employee/leave/': {
      id: '/employee/leave/'
      path: '/leave'
      fullPath: '/employee/leave/'
      preLoaderRoute: typeof EmployeeLeaveIndexRouteImport
      parentRoute: typeof EmployeeRoute
    }
    '/employee/appraisals/': {
      id: '/employee/appraisals/'
      path: '/appraisals'
      fullPath: '/employee/appraisals/'
      preLoaderRoute: typeof EmployeeAppraisalsIndexRouteImport
      parentRoute: typeof EmployeeRoute
    }
    '/_platform/platform/': {
      id: '/_platform/platform/'
      path: '/platform'
      fullPath: '/platform/'
      preLoaderRoute: typeof PlatformPlatformIndexRouteImport
      parentRoute: typeof PlatformRoute
    }
    '/_dm/distrimarket/': {
      id: '/_dm/distrimarket/'
      path: '/distrimarket'
      fullPath: '/distrimarket/'
      preLoaderRoute: typeof DmDistrimarketIndexRouteImport
      parentRoute: typeof DmRoute
    }
    '/_app/webhooks/': {
      id: '/_app/webhooks/'
      path: '/webhooks'
      fullPath: '/webhooks/'
      preLoaderRoute: typeof AppWebhooksIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staff/': {
      id: '/_app/staff/'
      path: '/staff'
      fullPath: '/staff/'
      preLoaderRoute: typeof AppStaffIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/smartspace/': {
      id: '/_app/smartspace/'
      path: '/smartspace'
      fullPath: '/smartspace/'
      preLoaderRoute: typeof AppSmartspaceIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/': {
      id: '/_app/sales/'
      path: '/sales'
      fullPath: '/sales/'
      preLoaderRoute: typeof AppSalesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reporting/': {
      id: '/_app/reporting/'
      path: '/reporting'
      fullPath: '/reporting/'
      preLoaderRoute: typeof AppReportingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/promotions/': {
      id: '/_app/promotions/'
      path: '/promotions'
      fullPath: '/promotions/'
      preLoaderRoute: typeof AppPromotionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile/': {
      id: '/_app/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AppProfileIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/products/': {
      id: '/_app/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof AppProductsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/procurement/': {
      id: '/_app/procurement/'
      path: '/procurement'
      fullPath: '/procurement/'
      preLoaderRoute: typeof AppProcurementIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pos/': {
      id: '/_app/pos/'
      path: '/pos'
      fullPath: '/pos/'
      preLoaderRoute: typeof AppPosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/petty-cash/': {
      id: '/_app/petty-cash/'
      path: '/petty-cash'
      fullPath: '/petty-cash/'
      preLoaderRoute: typeof AppPettyCashIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payroll/': {
      id: '/_app/payroll/'
      path: '/payroll'
      fullPath: '/payroll/'
      preLoaderRoute: typeof AppPayrollIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payments/': {
      id: '/_app/payments/'
      path: '/payments'
      fullPath: '/payments/'
      preLoaderRoute: typeof AppPaymentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/partner/': {
      id: '/_app/partner/'
      path: '/partner'
      fullPath: '/partner/'
      preLoaderRoute: typeof AppPartnerIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory/': {
      id: '/_app/inventory/'
      path: '/inventory'
      fullPath: '/inventory/'
      preLoaderRoute: typeof AppInventoryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hospitality/': {
      id: '/_app/hospitality/'
      path: '/hospitality'
      fullPath: '/hospitality/'
      preLoaderRoute: typeof AppHospitalityIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/field-sales/': {
      id: '/_app/field-sales/'
      path: '/field-sales'
      fullPath: '/field-sales/'
      preLoaderRoute: typeof AppFieldSalesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/expenses/': {
      id: '/_app/expenses/'
      path: '/expenses'
      fullPath: '/expenses/'
      preLoaderRoute: typeof AppExpensesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/empties/': {
      id: '/_app/empties/'
      path: '/empties'
      fullPath: '/empties/'
      preLoaderRoute: typeof AppEmptiesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/': {
      id: '/_app/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof AppDocumentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/': {
      id: '/_app/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppDashboardIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bom/': {
      id: '/_app/bom/'
      path: '/bom'
      fullPath: '/bom/'
      preLoaderRoute: typeof AppBomIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/': {
      id: '/_app/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof AppBillingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit/': {
      id: '/_app/audit/'
      path: '/audit'
      fullPath: '/audit/'
      preLoaderRoute: typeof AppAuditIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai/': {
      id: '/_app/ai/'
      path: '/ai'
      fullPath: '/ai/'
      preLoaderRoute: typeof AppAiIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounting/': {
      id: '/_app/accounting/'
      path: '/accounting'
      fullPath: '/accounting/'
      preLoaderRoute: typeof AppAccountingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hospitality/resources': {
      id: '/_app/hospitality/resources'
      path: '/hospitality/resources'
      fullPath: '/hospitality/resources'
      preLoaderRoute: typeof AppHospitalityResourcesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hospitality/reservations': {
      id: '/_app/hospitality/reservations'
      path: '/hospitality/reservations'
      fullPath: '/hospitality/reservations'
      preLoaderRoute: typeof AppHospitalityReservationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hospitality/kitchen': {
      id: '/_app/hospitality/kitchen'
      path: '/hospitality/kitchen'
      fullPath: '/hospitality/kitchen'
      preLoaderRoute: typeof AppHospitalityKitchenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hospitality/housekeeping': {
      id: '/_app/hospitality/housekeeping'
      path: '/hospitality/housekeeping'
      fullPath: '/hospitality/housekeeping'
      preLoaderRoute: typeof AppHospitalityHousekeepingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hospitality/group-bookings': {
      id: '/_app/hospitality/group-bookings'
      path: '/hospitality/group-bookings'
      fullPath: '/hospitality/group-bookings'
      preLoaderRoute: typeof AppHospitalityGroupBookingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hospitality/folios': {
      id: '/_app/hospitality/folios'
      path: '/hospitality/folios'
      fullPath: '/hospitality/folios'
      preLoaderRoute: typeof AppHospitalityFoliosRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppHospitalityFoliosRoute: typeof AppHospitalityFoliosRoute
  AppHospitalityGroupBookingsRoute: typeof AppHospitalityGroupBookingsRoute
  AppHospitalityHousekeepingRoute: typeof AppHospitalityHousekeepingRoute
  AppHospitalityKitchenRoute: typeof AppHospitalityKitchenRoute
  AppHospitalityReservationsRoute: typeof AppHospitalityReservationsRoute
  AppHospitalityResourcesRoute: typeof AppHospitalityResourcesRoute
  AppAccountingIndexRoute: typeof AppAccountingIndexRoute
  AppAiIndexRoute: typeof AppAiIndexRoute
  AppAuditIndexRoute: typeof AppAuditIndexRoute
  AppBillingIndexRoute: typeof AppBillingIndexRoute
  AppBomIndexRoute: typeof AppBomIndexRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
  AppDocumentsIndexRoute: typeof AppDocumentsIndexRoute
  AppEmptiesIndexRoute: typeof AppEmptiesIndexRoute
  AppExpensesIndexRoute: typeof AppExpensesIndexRoute
  AppFieldSalesIndexRoute: typeof AppFieldSalesIndexRoute
  AppHospitalityIndexRoute: typeof AppHospitalityIndexRoute
  AppInventoryIndexRoute: typeof AppInventoryIndexRoute
  AppPartnerIndexRoute: typeof AppPartnerIndexRoute
  AppPaymentsIndexRoute: typeof AppPaymentsIndexRoute
  AppPayrollIndexRoute: typeof AppPayrollIndexRoute
  AppPettyCashIndexRoute: typeof AppPettyCashIndexRoute
  AppPosIndexRoute: typeof AppPosIndexRoute
  AppProcurementIndexRoute: typeof AppProcurementIndexRoute
  AppProductsIndexRoute: typeof AppProductsIndexRoute
  AppProfileIndexRoute: typeof AppProfileIndexRoute
  AppPromotionsIndexRoute: typeof AppPromotionsIndexRoute
  AppReportingIndexRoute: typeof AppReportingIndexRoute
  AppSalesIndexRoute: typeof AppSalesIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSmartspaceIndexRoute: typeof AppSmartspaceIndexRoute
  AppStaffIndexRoute: typeof AppStaffIndexRoute
  AppWebhooksIndexRoute: typeof AppWebhooksIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppHospitalityFoliosRoute: AppHospitalityFoliosRoute,
  AppHospitalityGroupBookingsRoute: AppHospitalityGroupBookingsRoute,
  AppHospitalityHousekeepingRoute: AppHospitalityHousekeepingRoute,
  AppHospitalityKitchenRoute: AppHospitalityKitchenRoute,
  AppHospitalityReservationsRoute: AppHospitalityReservationsRoute,
  AppHospitalityResourcesRoute: AppHospitalityResourcesRoute,
  AppAccountingIndexRoute: AppAccountingIndexRoute,
  AppAiIndexRoute: AppAiIndexRoute,
  AppAuditIndexRoute: AppAuditIndexRoute,
  AppBillingIndexRoute: AppBillingIndexRoute,
  AppBomIndexRoute: AppBomIndexRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppDashboardIndexRoute: AppDashboardIndexRoute,
  AppDocumentsIndexRoute: AppDocumentsIndexRoute,
  AppEmptiesIndexRoute: AppEmptiesIndexRoute,
  AppExpensesIndexRoute: AppExpensesIndexRoute,
  AppFieldSalesIndexRoute: AppFieldSalesIndexRoute,
  AppHospitalityIndexRoute: AppHospitalityIndexRoute,
  AppInventoryIndexRoute: AppInventoryIndexRoute,
  AppPartnerIndexRoute: AppPartnerIndexRoute,
  AppPaymentsIndexRoute: AppPaymentsIndexRoute,
  AppPayrollIndexRoute: AppPayrollIndexRoute,
  AppPettyCashIndexRoute: AppPettyCashIndexRoute,
  AppPosIndexRoute: AppPosIndexRoute,
  AppProcurementIndexRoute: AppProcurementIndexRoute,
  AppProductsIndexRoute: AppProductsIndexRoute,
  AppProfileIndexRoute: AppProfileIndexRoute,
  AppPromotionsIndexRoute: AppPromotionsIndexRoute,
  AppReportingIndexRoute: AppReportingIndexRoute,
  AppSalesIndexRoute: AppSalesIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSmartspaceIndexRoute: AppSmartspaceIndexRoute,
  AppStaffIndexRoute: AppStaffIndexRoute,
  AppWebhooksIndexRoute: AppWebhooksIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResendVerificationRoute: typeof AuthResendVerificationRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResendVerificationRoute: AuthResendVerificationRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DmRouteChildren {
  DmDistrimarketIndexRoute: typeof DmDistrimarketIndexRoute
}

const DmRouteChildren: DmRouteChildren = {
  DmDistrimarketIndexRoute: DmDistrimarketIndexRoute,
}

const DmRouteWithChildren = DmRoute._addFileChildren(DmRouteChildren)

interface PlatformRouteChildren {
  PlatformPlatformIndexRoute: typeof PlatformPlatformIndexRoute
}

const PlatformRouteChildren: PlatformRouteChildren = {
  PlatformPlatformIndexRoute: PlatformPlatformIndexRoute,
}

const PlatformRouteWithChildren = PlatformRoute._addFileChildren(
  PlatformRouteChildren,
)

interface EmployeeRouteChildren {
  EmployeeIndexRoute: typeof EmployeeIndexRoute
  EmployeeAppraisalsIndexRoute: typeof EmployeeAppraisalsIndexRoute
  EmployeeLeaveIndexRoute: typeof EmployeeLeaveIndexRoute
  EmployeeLoansIndexRoute: typeof EmployeeLoansIndexRoute
  EmployeePayslipsIndexRoute: typeof EmployeePayslipsIndexRoute
  EmployeeProfileIndexRoute: typeof EmployeeProfileIndexRoute
}

const EmployeeRouteChildren: EmployeeRouteChildren = {
  EmployeeIndexRoute: EmployeeIndexRoute,
  EmployeeAppraisalsIndexRoute: EmployeeAppraisalsIndexRoute,
  EmployeeLeaveIndexRoute: EmployeeLeaveIndexRoute,
  EmployeeLoansIndexRoute: EmployeeLoansIndexRoute,
  EmployeePayslipsIndexRoute: EmployeePayslipsIndexRoute,
  EmployeeProfileIndexRoute: EmployeeProfileIndexRoute,
}

const EmployeeRouteWithChildren = EmployeeRoute._addFileChildren(
  EmployeeRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  DmRoute: DmRouteWithChildren,
  PlatformRoute: PlatformRouteWithChildren,
  EmployeeRoute: EmployeeRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
  SBranchIdRoute: SBranchIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
